import { Box, FormControl, MenuItem, Select } from "@mui/material"
import { useEffect, useState } from "react"
import { useGetAdminAndSupers } from "../features/settings/hooks"
import { Fetching } from "./Fetching"

export const UserSelectFieldComponent = (props: any) => {
    const { id, name, label, fieldValue, onDataEntry, variant, required } = props
    const { data: users, isFetching: isFetchingUsers } = useGetAdminAndSupers('users')
    const existingUser = fieldValue ? fieldValue : ''
    const [user, setUser] = useState<string>(existingUser)

    const onUserChange = (event?: React.ChangeEvent<HTMLInputElement> | any) => {
        setUser(event.target.value)
    }

    useEffect(() => {
        if (user) {
            const selectedUser = {
                name: name,
                value: user
            }
            onDataEntry(selectedUser)
        }
    }, [user, name, onDataEntry])

    if (isFetchingUsers) {
        <Fetching />
    }

    return <>
        {users ?
            <>
                <Box className='formfield'>
                    <FormControl required={required} sx={{ mt: 1, mb: 1, minWidth: 300 }}>
                        <Select
                            id={id}
                            name={name}
                            placeholder={`Select a ${label}`}
                            variant={variant}
                            value={user}
                            required={required}
                            onChange={onUserChange}
                        >
                            {users.map((user: any, key: any) => <MenuItem
                                key={key}
                                value={user._id}>
                                {user.email}
                            </MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
            </>
            : null}
    </>
}

export default UserSelectFieldComponent